import React from "react";
import Modal, { Props } from "@ff/ui/Modal";

export default function CustomizedModal(props: Props){
  const newProps = {
    ...props,
    closeIconProps: {
    position: 'relative' as any,
    top: '20px',
    right: '40px',
    width: '20px',
    height: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '20px',
    background: 'black',
    color: 'white',
    borderRadius: '10px',
  },
  backdrop: true,
  closeIcon: true,
  closeOnBackdrop: true,
  styleProps: {
    border: '1px solid rgba(0, 0, 0, 0.5)',
    borderRadius: '30px',
  }
}

  return(
    <Modal {...newProps}>
      {newProps.children}
    </Modal>
  );
}